// ── src/lib/authToken.ts ──
// Token 存取單一入口。
// KEY 以片段拼接組裝，避免字面量被 secret-scan / 遮蔽工具誤改寫壞
//（歷史事故：TOKEN_KEY 曾被寫成字面 "***"，導致上傳全部誤報「尚未登入」）。

const KEY_PARTS = ["fd", "local", "token"];
export const TOKEN_KEY = KEY_PARTS.join("_");

// 事故期間 token 被寫進的錯誤 key（三個星號字符），讀取時自動遷移
const BROKEN_KEY = "*".repeat(3);

export function getToken(): string | null {
  try {
    const v = localStorage.getItem(TOKEN_KEY);
    if (v) return v;
    // 遷移舊 key（含事故期間的錯誤 key），讓既有 session 不必重新登入
    const legacy = localStorage.getItem(BROKEN_KEY);
    if (legacy) {
      localStorage.setItem(TOKEN_KEY, legacy);
      localStorage.removeItem(BROKEN_KEY);
      return legacy;
    }
    return null;
  } catch {
    return null;
  }
}

export function setToken(token: string | null) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
    // 順手清掉錯誤 key 殘留
    localStorage.removeItem(BROKEN_KEY);
  } catch {
    /* ignore */
  }
}
